export function hasVoicesInteriorScene(pathname = '') {
  const path = pathname.toLowerCase().replace(/\/+$/, '');
  return isVoicesRoute(path) && (/^\/(services|customer-stories)\/[^/]+$/.test(path)
    || ['/ai-agents', '/managed-agents', '/who-we-are', '/careers'].includes(path));
}

export function hasVoicesEnding(pathname = '') {
  const path = pathname.toLowerCase().replace(/\/+$/, '');
  return isVoicesRoute(path) && (/^\/(services|customer-stories|article|blog)\/[^/]+$/.test(path)
    || ['/services', '/work', '/who-we-are', '/careers', '/events', '/case-studies', '/products/edi-converter', '/ai-agents', '/managed-agents', '/implementation-guide'].includes(path));
}

export function isVoicesRoute(pathname) {
  let path;
  try {
    path = decodeURIComponent((pathname || '/').split(/[?#]/)[0]).toLowerCase().replace(/\/+$/, '') || '/';
  } catch {
    return false;
  }
  if (/^\/(hrm|e|sow|admin|backend)(\/|$)/.test(path)) return false;
  if (path.startsWith('/djucncbv')) return false;
  return true;
}
